<template>
  <span class="value-import-origin" :title="$t('models.project_lead.import_origins.' + value)" :class="'origin-' + value"><i class="icon">{{icon}}</i></span>
  </template>
  <script>
  export default {
    props: ['item', 'column', 'model'],
    computed: {
      value(){
        return eval('this.item.' + this.column.name)
      },
      icon(){
        if(this.value == 'crm'){
          return "assignment"
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
.value-import-origin{
  color: #959595;
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// CollectionValueImportOrigin.vue?6d89ccbc